import type { ImportResultDto } from "../api/types";

const count = (n: number, one: string, many: string) =>
  `${n} ${n === 1 ? one : many}`;

/**
 * One line saying what a statement import did — for a caller whose import
 * dialog closes on success, so its in-dialog alert is never seen. Same counts
 * as that alert; the parts for skipped and merged rows only appear when there
 * were any.
 */
export const importOutcomeMessage = ({
  imported,
  skippedFinalized,
  mergedTransfers,
}: ImportResultDto): string =>
  [
    `Imported ${count(imported, "transaction", "transactions")}`,
    skippedFinalized > 0 && `${skippedFinalized} skipped`,
    mergedTransfers > 0 &&
      `${count(mergedTransfers, "internal transfer", "internal transfers")} merged`,
  ]
    .filter(Boolean)
    .join(", ");
